import {Directive, ElementRef, HostListener, Input, Renderer2} from '@angular/core';
import {ActivatedRoute, Router, RouterLink} from "@angular/router";

@Directive({
  selector: '[customRouterLink]'
})
export class CustomRouterLinkDirective extends RouterLink {
  @Input() customRouterLink: string|any[];
  @Input() set routerLink(commands: any[] | string | null | undefined) {
    super.routerLink = commands;
  }

  @HostListener('mouseup', ['$event']) middleClick($event){
    if($event.button === 1) {
      console.log( this.urlTree.toString());
      window.open(this.calculateUrl());
    }
  }

  onClick(): boolean {
    console.log(event);
    if((event as PointerEvent).ctrlKey) {
      window.open(this.calculateUrl());
      return false;
    } else {
      this.routerLink = this.customRouterLink;
      return super.onClick((event as PointerEvent).button, (event as PointerEvent).ctrlKey, (event as PointerEvent).shiftKey, (event as PointerEvent).altKey, (event as PointerEvent).metaKey)
    }
  }

  private calculateUrl() {
    let url = '';
    for(let part of this.customRouterLink) {
      part = '' + part;
      if(!part.startsWith('/') && !url.endsWith('/')) {
        url += '/';
      }
      url += part;
    }
    if(this.queryParams) {
      let params = [];
      for(let key of Object.keys(this.queryParams)) {
        params.push(key + '=' + encodeURIComponent(this.queryParams[key]));
      }
      url += '?' + params.join('&');
    }
    if(this.fragment) {
      url += '#' + this.fragment;
    }

    return url;
  }
}
